export default __webpack_public_path__ + "static/media/profileCard.fec207f9.png";